import { List as RecipientsList } from './List';

export default RecipientsList;
